// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__27NuX","header":"PatientBlock_header__BhMlQ","label":"PatientBlock_label__18ZdS","option":"PatientBlock_option__rQ93_"};